import HeroHeading from '../Headings/HeroHeading'
import HeroDescription from '../Headings/HeroDescription'
import BookACallButton from '../Buttons/Specials/BookACallButton'

export default function HeroBanner() {
    return (
        <div className="md:container mx-auto px-2">
            <div className="flex flex-col md:flex-row items-center space-y-5 md:space-y-0 md:space-x-8">
                <div className="md:w-2/4 text-center md:text-left md:space-y-6 space-y-2 px-1">
                    <HeroHeading>Book a Coaching Call</HeroHeading>
                    <HeroDescription>
                        <p className="text-left">
                            Unlock the full potential of your direct mail
                            campaigns with our personalized coaching sessions.
                            Our experts are here to guide you through every step
                            of the process, ensuring you achieve the best
                            possible results.
                        </p>
                    </HeroDescription>
                    <div className="hidden md:block py-4 w-96">
                        <BookACallButton />
                    </div>
                </div>
                <div className="md:w-2/4 md:block">
                    <img
                        src="/assets/coaching/hero.png"
                        alt="coaching"
                        className="w-full h-auto"
                    />
                </div>
                <div className="py-4 w-96 block md:hidden">
                    <BookACallButton />
                </div>
            </div>
        </div>
    )
}
